import type { DealOaApi } from '@openx/types/deal';

export const isDealDeleted = (deal: DealOaApi): boolean => {
  return deal.deleted !== 0;
};
